export default __webpack_public_path__ + "static/assets/e4b48cebac1ef827e73751f398951393.svg";